var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.nothingData && !_vm.nothingData.inSelect
        ? _c(
            "div",
            { staticClass: "mb-2" },
            [
              _c(
                "b-form-checkbox",
                {
                  on: { change: _vm.nothingChanged },
                  model: {
                    value: _vm.nothing,
                    callback: function($$v) {
                      _vm.nothing = $$v
                    },
                    expression: "nothing"
                  }
                },
                [_vm._v(_vm._s(_vm.nothingData.text))]
              ),
              _vm._v(" "),
              !_vm.nothing && (!_vm.selected || _vm.selected.length === 0)
                ? _c("div", { staticClass: "error" }, [
                    _vm._v(_vm._s(_vm.nothingData.error))
                  ])
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("b-select", {
        class: { smaller: _vm.smaller },
        attrs: { options: _vm.options },
        on: {
          input: _vm.selectedChanged,
          change: function($event) {
            return _vm.$emit("change")
          }
        },
        scopedSlots: _vm._u(
          [
            _vm.selected === undefined
              ? {
                  key: "first",
                  fn: function() {
                    return [
                      _c(
                        "b-form-select-option",
                        { attrs: { value: undefined } },
                        [_vm._v(_vm._s(_vm.undefinedTextOptionText))]
                      )
                    ]
                  },
                  proxy: true
                }
              : null
          ],
          null,
          true
        ),
        model: {
          value: _vm.selected,
          callback: function($$v) {
            _vm.selected = $$v
          },
          expression: "selected"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }